import { Phone, Mail, CalendarClock, CheckSquare, StickyNote } from "lucide-react";

export { eur } from "@/components/chef/CommercialEditor";
export const fdate = (s) => (s ? new Date(String(s).slice(0, 10) + "T12:00:00").toLocaleDateString("fr-FR") : "—");
export const fdt = (s) => (s ? new Date(s).toLocaleString("fr-FR", { day: "2-digit", month: "short", hour: "2-digit", minute: "2-digit" }) : "—");
export const toLocalInput = (iso) => {
  if (!iso) return "";
  const d = new Date(iso);
  const p = (n) => String(n).padStart(2, "0");
  return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())}T${p(d.getHours())}:${p(d.getMinutes())}`;
};

export const STAGE_STYLE = {
  nouveau: { bg: "bg-[#0A0A0A]", text: "text-white", dot: "#0A0A0A" },
  qualifie: { bg: "bg-[#002FA7]", text: "text-white", dot: "#002FA7" },
  proposition: { bg: "bg-[#FFD700]", text: "text-black", dot: "#FFD700" },
  negociation: { bg: "bg-[#D97706]", text: "text-white", dot: "#D97706" },
  gagne: { bg: "bg-[#059669]", text: "text-white", dot: "#059669" },
  perdu: { bg: "bg-[#E60000]", text: "text-white", dot: "#E60000" },
};
export const STATUS_STYLE = { prospect: "bg-[#FFD700] text-black", client: "bg-[#059669] text-white", inactif: "bg-[#DEE2E6] text-[#495057]" };
export const KIND_ICON = { note: StickyNote, appel: Phone, email: Mail, rdv: CalendarClock, tache: CheckSquare };
export const OPEN_STAGES = ["nouveau", "qualifie", "proposition", "negociation"];
